export const USER_SUB_PARAM_NAME = 'userSub';

export interface UserRouteParams {
  [USER_SUB_PARAM_NAME]?: string;
}
